import React from 'react';
 
const Footer = () => {
    


    return ( 
        <>
                
       

                <div class="container-fluid mt-4">
                            <div class="row">
                                <div class="col-12">

                                    <footer
                                        class="footer-area d-sm-flex justify-content-center align-items-center justify-content-between">

                                        <div class="copywrite-text">
                                            <p>Powered by @<a href="#">Digital Neurones</a></p>
                                        </div>
                                        {/* <div class="fotter-icon text-center">
                                            <a href="#" class="action-item mr-2" data-bs-toggle="tooltip" title="Facebook">
                                                <i class="fa fa-facebook" aria-hidden="true"></i>
                                            </a>
                                            <a href="#" class="action-item mr-2" data-bs-toggle="tooltip" title="Twitter">
                                                <i class="fa fa-twitter" aria-hidden="true"></i>
                                            </a>
                                            <a href="#" class="action-item mr-2" data-bs-toggle="tooltip" title="Pinterest">
                                                <i class="fa fa-pinterest-p" aria-hidden="true"></i>
                                            </a>
                                            <a href="#" class="action-item mr-2" data-bs-toggle="tooltip" title="Instagram">
                                                <i class="fa fa-instagram" aria-hidden="true"></i>
                                            </a>
                                        </div> */}
                                    </footer>
                                </div>
                            </div>
                        </div>








        </>
        );
    };

export default Footer; 
 
